import { H4 } from 'assets/styled';
import { Modal } from '../Modal/Modal';
import { Formik } from 'formik';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ApplyWrapper,
  ColumnContainer,
  Wrapper,
  Label,
  Title,
  TitleContainer,
  Container,
  FormWrapper,
} from './AddUserModal.styled';
import { Input } from 'components/Input/InputFormik';
import Button from 'components/Button/Button';
import { addUserSchema } from './validation';
import { useAddUser } from './hooks';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';

interface IAddUserModalProps {
  onCancel: () => void;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const AddUserModal = ({
  isOpen,
  setIsOpen,
  onCancel,
}: IAddUserModalProps) => {
  const { t } = useTranslation();
  const { isSmallTablet } = useBreakpointFlag();
  const { mutate: addUser, isLoading: isLoadingAddUser } = useAddUser();

  const handleApply = (values: { email: string }) => {
    addUser(values);
    setIsOpen(false);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      modalStyle={{
        position: 'fixed',
        margin: 'auto',
        width: isSmallTablet ? '90%' : '500rem',
        minWidth: isSmallTablet ? '90%' : 'auto',
      }}
    >
      <Container>
        <TitleContainer>
          <Title>{t('Add user')}</Title>
        </TitleContainer>
        <FormWrapper>
          <Formik
            enableReinitialize
            onSubmit={() => {
              //
            }}
            initialValues={{
              email: '',
            }}
            validationSchema={addUserSchema}
            validateOnMount
            validateOnChange
          >
            {({ values, handleBlur, errors, isValid, touched }) => {
              return (
                <Wrapper>
                  <ColumnContainer>
                    <Label>
                      <H4>{t('Email').toUpperCase()}</H4>
                    </Label>
                    <Input
                      errorMessage={touched['email'] ? errors['email'] : ''}
                      onBlur={(e) => {
                        handleBlur(e);
                      }}
                      height={'43rem'}
                      name="email"
                      wrapperStyles={{
                        width: '100%',
                      }}
                    />
                  </ColumnContainer>
                  <ApplyWrapper>
                    <Button
                      onClick={onCancel}
                      secondary
                      width="200rem"
                      label={t('Cancel')}
                    />
                    <Button
                      disabled={isLoadingAddUser || !values.email || !isValid}
                      onClick={() => {
                        if (isValid) {
                          handleApply(values);
                        }
                      }}
                      primary
                      width="200rem"
                      label={t('Confirm')}
                    />
                  </ApplyWrapper>
                </Wrapper>
              );
            }}
          </Formik>
        </FormWrapper>
      </Container>
    </Modal>
  );
};
